import React, { useState } from 'react';
import cn from 'classnames';
import AngleDown from 'react-icons/lib/fa/angle-down';
import styles from './style.scss';

import Button from '../../../../common/Button/Button';
import Checkbox from '../../../../common/Checkbox/Checkbox';
import tracker from '../../../../../services/tracker';
import i18n from '../../../../../i18n';
import { useTranslation } from 'react-i18next';
import { gaEvent, trackGA } from 'services/ga';

const variants = {
  chernInt: { param: 'chernInt', key: 'chernInt', text: i18n.t('components.header.filtersBar.filters.decoration.chernInt'), event: 'Web_Filters_Chern_Int' },
  chistInt: { param: 'chistInt', key: 'chistInt', text: i18n.t('components.header.filtersBar.filters.decoration.chistInt'), event: 'Web_Filters_Сhist_Int' },
  predChistInt: { param: 'predChistInt', key: 'predChistInt', text: i18n.t('components.header.filtersBar.filters.decoration.predChistInt'), event: 'Web_Filters_Pred_Сhist_Int' },
  remInt: { param: 'remInt', key: 'remInt', text: i18n.t('components.header.filtersBar.filters.decoration.remInt'), event: 'Web_Filters_Rem_Int' },
  whiteBox: { param: 'whiteBox', key: 'whiteBox', text: i18n.t('components.header.filtersBar.filters.decoration.whiteBox'), event: 'Web_Filters_White_Box' },
  repair: { param: 'repair', key: 'repair', text: i18n.t('components.header.filtersBar.filters.decoration.repair'), event: 'Web_Filters_Repair' }
  // 'chastRemInt': { param: 'chastRemInt', key: 'chastRemInt', text: i18n.t('components.header.filtersBar.filters.decoration.chastRemInt') }
};

export const parseSearch = (search) => {
  const { interior } = search;
  if (!interior) {
    return { interior: [] };
  }
  const keys = interior.split(',');
  return {
    interior: Object.keys(variants)
      .reduce((prev, cur) => {
        const variant = variants[cur];
        if (keys.includes(variant.param)) {
          prev.push(variant.key);
        }
        return prev;
      }, [])
  };
};

export const compileSearch = (data) => {
  const { interior: keys } = data;
  if (!keys || !keys.length) {
    return { interior: undefined };
  }

  return {
    interior: Object.keys(variants)
      .reduce((prev, cur) => {
        const variant = variants[cur];
        if (keys.includes(variant.key)) {
          prev.push(variant.param);
        }
        return prev;
      }, [])
      .join(',') || undefined
  };
};

export const compileRequest = (data) => {
  const { interior } = data;
  return { interior: interior.length ? interior : undefined };
};

export const getRequest = (search) => compileRequest(parseSearch(search));

const countDefinedProps = (obj) => Object.values(obj).filter(value => value).length;

export const subtext = (search) => {
  const { interior: keys } = parseSearch(search);
  return Object.keys(variants)
    .reduce((prev, cur) => {
      const variant = variants[cur];
      if (keys.includes(variant.key)) {
        prev.push(variant.text);
      }
      return prev;
    }, [])
    .join(', ') || i18n.t('components.header.filtersBar.filters.decoration.notSelected');
};

const Decoration = (props) => {
  const { t } = useTranslation();
  const handleClearClick = (e) => {
    e.stopPropagation();
    const { dropdownData } = props;
    const data = { interior: [] };
    const compiledSearch = compileSearch(data);
    const compiledRequest = compileRequest(data);
    dropdownData(compiledSearch, compiledRequest);
    props.onClearClick && props.onClearClick('interior');

    trackGA(gaEvent.filterClearButtonsClick({
      eventContent: 'eshchyo',
      eventContext: props.mode,
      productType: props.objectType,
      user_id: props.profile.id
    }));
  };

  const [isExpanded, setIsExpanded] = useState(true);

  const handleCheckboxClick = (key, add) => {
    const { search, dropdownData, eventData, mode, objectType, profile } = props;
    const { interior: keys } = parseSearch(search);
    const interior = [...keys];

    tracker.sendVariantEvent({ variants, key, selected: add, eventData });

    const variant = variants[Object.keys(variants).find(v => variants[v].key === key)];
    const variantName = variant ? variant.text : 'Unknown variant';
    const isChecked = add ? 'on' : 'off';

    trackGA(gaEvent.filterCheckboxesClick({
      eventContent: [variantName, ` | ${isChecked}`],
      eventContext: mode,
      productType: objectType,
      user_id: profile.id
    }));

    if (interior.includes(key) !== add) {
      if (add) {
        interior.push(key);
      } else {
        interior.splice(interior.indexOf(key), 1);
      }
    }

    const data = { interior };
    const compiledSearch = compileSearch(data);
    const compiledRequest = compileRequest(data);
    dropdownData(compiledSearch, compiledRequest);
  };

  const checkbox = (key) => {
    const { search, additional } = props;
    const { interior } = parseSearch(search);

    const variant = variants[key];
    return (
      <Checkbox
        className={styles.Checkbox}
        innerStyle={styles.FiltersCheckInner}
        classNameClone="CheckboxCloneFilters"
        checked={interior.includes(variant.key)}
        handle={value => handleCheckboxClick(variant.key, value)}
        additional={additional}
        text={variant.text}
      />
    );
  };

  const { className, additional, search, isCottegePage } = props;
  const { interior } = parseSearch(search);
  const name = isCottegePage ? t('components.header.filtersBar.filters.decoration.title') : t('components.header.filtersBar.filters.decoration.titleFull');
  const selectedCount = interior.length;

  return (
    <div className={cn(styles.Menu, className, { [styles.Additional]: additional })}>
      <div className={styles.Header} onClick={() => setIsExpanded(!isExpanded)}>
        <span className={styles.Title}>
          {name}
          {selectedCount > 0 && ` (${selectedCount})`}
          <AngleDown className={cn(styles.Icon, { [styles.Active]: isExpanded })} />
        </span>
        {additional && interior.length > 0 && (
          <Button className={styles.Button} onClick={handleClearClick}>
            {t('components.header.filtersBar.filters.decoration.clear')}
          </Button>
        )}
      </div>
      {isExpanded && (<div className={styles.Checkboxes}>
        <div className={styles.FirstColumn}>
          {checkbox('whiteBox')}
          {checkbox('repair')}
        </div>
        <div className={styles.SecondColumn}>
          {checkbox('predChistInt')}
          {checkbox('chernInt')}
        </div>
        <div className={styles.ThirdColumn}>
          {checkbox('remInt')}
          {checkbox('chistInt')}
        </div>
      </div>)}
      {/* {additional ? (
        <div className={styles.ButtonWrap}>
          {!!interior.length &&
          <Button className={styles.Button} onClick={handleClearClick}>
            {t('components.header.filtersBar.filters.decoration.clear')}
          </Button>}
        </div>
        ) : (null)} */}
    </div>
  );
};

export default Decoration;



// WEBPACK FOOTER //
// ./src/components/Header/FiltersBar/Filters/Decoration/Decoration.js